import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if ("serviceWorker" in navigator && environment.production) {
  navigator.serviceWorker
    .register("/assets/service-worker/insider-sw-sdk.js")
    .then((registration) => {
      console.log(
        "Insider Service Worker registrado com sucesso:",
        registration
      );
    })
    .catch((error) => {
      console.error("Falha ao registrar o Insider Service Worker:", error);
    });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

console.log("*************** ENVIRONMENT ***************")
console.log(environment);